import { gql } from '@apollo/client';

export interface PdaScanSetting {
    accountId: string;
    warehouseId: string;
    masterEnabled: boolean;
    vibrateEnabled: boolean;
    breathingLightEnabled: boolean;
    soundEnabled: boolean;
    soundId: string;
    lastUpdatedByType: string;
}

export interface AccountScanSetting {
    accountId: string;
    accountLoginName?: string | null;
    accountName: string;
    setting: PdaScanSetting;
}

export interface UpdateScanSettingInput {
    masterEnabled?: boolean;
    vibrateEnabled?: boolean;
    breathingLightEnabled?: boolean;
    soundEnabled?: boolean;
    soundId?: string;
}

export interface ScanSettingWarehouseNode {
    warehouseId: string;
    name: string;
    children: ScanSettingWarehouseNode[];
}

export type ScanSettingField = 'MASTER' | 'VIBRATE' | 'BREATHING_LIGHT' | 'SOUND';

export interface PdaScanSettingLog {
    accountId: string;
    warehouseId: string;
    action: string;
    operatorType: string;
    operatorId: string | null;
    operatorName: string | null;
    changedFieldsJson: string | null;
    source: string;
    createdAtMs: number | null;
}

export interface PdaScanSettingLogPage {
    content: PdaScanSettingLog[];
    total: number;
    page: number;
    pageSize: number;
}

export interface GetScanSettingWarehouseTreeResponse {
    getScanSettingWarehouseTree: ScanSettingWarehouseNode[];
}

export interface BatchUpdateWarehouseScanSettingResponse {
    batchUpdateWarehouseScanSetting: number;
}

export interface ListScanSettingLogsResponse {
    listScanSettingLogs: PdaScanSettingLogPage;
}

export interface ListAccountScanSettingsResponse {
    listAccountScanSettings: AccountScanSetting[];
}

export interface UpdateAccountScanSettingResponse {
    updateAccountScanSetting: PdaScanSetting;
}

export const LIST_ACCOUNT_SCAN_SETTINGS = gql`
    query ListAccountScanSettings($warehouseId: Long!) {
        listAccountScanSettings(warehouseId: $warehouseId) {
            accountId
            accountLoginName
            accountName
            setting {
                accountId
                warehouseId
                masterEnabled
                vibrateEnabled
                breathingLightEnabled
                soundEnabled
                soundId
                lastUpdatedByType
            }
        }
    }
`;

export const UPDATE_ACCOUNT_SCAN_SETTING = gql`
    mutation UpdateAccountScanSetting($accountId: Long!, $warehouseId: Long!, $input: UpdateScanSettingInput!) {
        updateAccountScanSetting(accountId: $accountId, warehouseId: $warehouseId, input: $input) {
            accountId
            warehouseId
            masterEnabled
            vibrateEnabled
            breathingLightEnabled
            soundEnabled
            soundId
            lastUpdatedByType
        }
    }
`;

export const GET_SCAN_SETTING_WAREHOUSE_TREE = gql`
    query GetScanSettingWarehouseTree {
        getScanSettingWarehouseTree {
            warehouseId
            name
            children {
                warehouseId
                name
            }
        }
    }
`;

export const BATCH_UPDATE_WAREHOUSE_SCAN_SETTING = gql`
    mutation BatchUpdateWarehouseScanSetting($warehouseId: Long!, $field: ScanSettingField!, $enabled: Boolean!) {
        batchUpdateWarehouseScanSetting(warehouseId: $warehouseId, field: $field, enabled: $enabled)
    }
`;

export interface PdaScanSoundFile {
    soundId: string;
    labelKey: string;
    objectKey: string | null;
    url: string | null;
    createdBy: number | null;
    updatedBy: number | null;
    /** 创建时间（unix timestamp 秒） */
    createdAt: number | null;
    /** 更新时间（unix timestamp 秒） */
    updatedAt: number | null;
}

export interface ListPdaScanSoundFilesResponse {
    listPdaScanSoundFiles: PdaScanSoundFile[];
}

export interface UpdatePdaScanSoundFileResponse {
    updatePdaScanSoundFile: boolean;
}

export interface UploadPdaScanSoundResponse {
    uploadPdaScanSound: {
        objectKey: string;
        publicUrl: string;
    };
}

export const UPLOAD_PDA_SCAN_SOUND = gql`
    mutation UploadPdaScanSound($input: UploadPdaScanSoundInput!) {
        uploadPdaScanSound(input: $input) {
            objectKey
            publicUrl
        }
    }
`;

export const LIST_PDA_SCAN_SOUND_FILES = gql`
    query ListPdaScanSoundFiles {
        listPdaScanSoundFiles {
            soundId
            labelKey
            objectKey
            url
            createdBy
            updatedBy
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_PDA_SCAN_SOUND_FILE = gql`
    mutation UpdatePdaScanSoundFile($soundId: String!, $objectKey: String!) {
        updatePdaScanSoundFile(soundId: $soundId, objectKey: $objectKey)
    }
`;

export const LIST_SCAN_SETTING_LOGS = gql`
    query ListScanSettingLogs($accountId: Long, $warehouseId: Long, $page: Int!, $pageSize: Int!) {
        listScanSettingLogs(accountId: $accountId, warehouseId: $warehouseId, page: $page, pageSize: $pageSize) {
            content {
                accountId
                warehouseId
                action
                operatorType
                operatorId
                operatorName
                changedFieldsJson
                source
                createdAtMs
            }
            total
            page
            pageSize
        }
    }
`;
